import * as e from "react";
import { forwardRef as l } from "react";
const t = l(function(C, n) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M4.4296 9.81398L14.1847 19.5693C12.6933 19.741 11.1829 19.5277 9.79733 18.9499L7.23979 21.5081C7.0839 21.664 6.8988 21.7878 6.69509 21.8722C6.49137 21.9566 6.27302 22 6.05251 22C5.832 22 5.61365 21.9566 5.40993 21.8722C5.20621 21.7878 5.02112 21.664 4.86523 21.5081L2.49151 19.1337C2.1768 18.8189 2 18.392 2 17.9469C2 17.5018 2.1768 17.0749 2.49151 16.7601L5.04905 14.2019C4.60166 13.1281 4.37199 11.9761 4.37336 10.8128C4.37336 10.4754 4.39267 10.1413 4.4296 9.81398ZM17.8032 13.7504C18.471 13.7504 19.1115 14.0156 19.5837 14.4878C20.056 14.96 20.3213 15.6005 20.3213 16.2683C20.3213 16.9361 20.056 17.5765 19.5837 18.0487C19.1115 18.5209 18.471 18.7862 17.8032 18.7862C17.1353 18.7862 16.4949 18.5209 16.0226 18.0487C15.5504 17.5765 15.2851 16.9361 15.2851 16.2683C15.2851 15.6005 15.5504 14.96 16.0226 14.4878C16.4949 14.0156 17.1353 13.7504 17.8032 13.7504ZM13.1867 2C18.055 2 22 5.9456 22 10.8128C22 11.9626 21.7801 13.0621 21.3789 14.0693L21.3075 13.9577C20.7936 13.1777 20.0341 12.5915 19.1494 12.2919C18.2646 11.9923 17.3052 11.9963 16.4231 12.3035C15.5409 12.6106 14.7864 13.2032 14.2791 13.9875C13.7718 14.7718 13.5407 15.7029 13.6223 16.6334L4.87278 7.88189C6.08063 4.45582 9.34659 2 13.1867 2Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  t as TableTennis
};
